/**
 * MIS-237: human-readable role display names, shared by client and server.
 *
 * `users.role` and `roles.type` carry machine slugs (`exec_pa`, `office_manager`, …).
 * The UI must never show a raw slug. Resolution order elsewhere is: the junction
 * row's `roles.name`, then the role looked up by UUID, then the deterministic slug
 * resolve. This map is the final fallback when none of those resolve — and the only
 * thing the client needs to turn a slug into a label.
 */
export const ROLE_LABELS: Record<string, string> = {
  owner: 'Owner',
  admin: 'Administrator',
  office_manager: 'Office Manager',
  exec_pa: 'Executive PA',
  accountant: 'Accountant',
};

/**
 * Turn a role slug (or an already human-readable name) into a display name.
 * Known slugs map to their label; anything else (an existing `roles.name` such as
 * "Executive PA", or an unknown value) is returned unchanged. Never returns a known
 * slug verbatim.
 */
export function roleDisplayName(slugOrName: string | null | undefined): string {
  if (!slugOrName) return '';
  return ROLE_LABELS[slugOrName] ?? slugOrName;
}
